import { IApplicationState } from "../state";
import { createSelector } from "@reduxjs/toolkit";
import { IPitState } from "../reducers/pit";

const pitStateSelector = (state: IApplicationState) => state.pit;

export const pitListSelector = createSelector(pitStateSelector, (pit: IPitState) => pit.pitList);

export const loadingSelector = createSelector(pitStateSelector,(pit: IPitState) => pit.loading);
